export default {
  pills(state) {
    return state.pills;
  }
};
